var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(this.$store.getters['Global/isLoggedIn'])?_c('NavBar'):_vm._e(),_c('div',{staticClass:"container-fluid w-100 container-fluid w-100"},[_c('router-view'),_c('VLibras')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }